import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "card-title mt-0" }

import DeleteModal from "@/components/UnexpectedEventAndAlertStatuseList/DeleteModal.vue"
import UnexpectedEventAndAlertStatuseList from "@/components/UnexpectedEventAndAlertStatuseList/UnexpectedEventAndAlertStatuseList.vue";
import getUnexpectedEventAndLongTimeDrivingExtensionsType from "@/types/requests/getUnexpectedEventAndLongTimeContinuousDrivingExtensions"
import { MANAGEMENT_OFFICE_TYPE, SUB_MANAGEMENT_OFFICE_TYPE, OPERATION_OFFICE_TYPE, DEPARTMENT_OFFICE_TYPE } from "@/services/consts";
import { formatDate } from "@/services/functions"
import getPagenatedUnexpectedEventAndLongTimeContinuousDrivingExtensionsType from "@/types/responses/getPagenatedUnexpectedEventAndLongTimeContinuousDrivingExtensions"
import UnexpectedEventModals from "@/components/DailyReportUpdateModalParts/UnexpectedEventModals.vue";
import unexpectedEventsAndLongTimeContinuousDrivingExtensions from "src/types/responses/unexpectedEventsAndLongTimeContinuousDrivingExtensions";
import { SELECTABLE_STATUSES } from '@/services/consts/unecpected_event_and_alert_status';
import SearchForm from "@/components/UnexpectedEventAndAlertStatuseList/SearchForm.vue";
import getOperationOfficeResponse from "@/types/responses/getOperationOffice";
import getDepartmentResponse from "@/types/responses/getDepartment";
import AuthorityCacheApi from "@/services/models/AuthorityCacheApi";
import getAccountResponse from "@/types/responses/getAccount";
import { useAuth } from "@/services/user/Auth0UserProvider";
import PaginateWithCount from "@/components/PaginateWithCount.vue";
import { Ref, ref, reactive, onMounted, watch } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import SelfAccountType from "@/types/SelfAccount";
import SelfOfficeType from "@/types/SelfOffice";
import { getSelfOffice } from "@/services/functions/operationOffice";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'UnexpectedEventAndAlertStatuseList',
  props: {
    showFlash: { type: Function },
    switchContentLoading: { type: Function }
  },
  setup(__props: any) {

document.title = i18n.global.t('pages.unexpectedEventAndAlertStatuses.title')
const { loginWithRedirect } = useAuth()
const currentPage: Ref<number> = ref(1)
const totalPage: Ref<number> = ref(0)
const itemsPerPage: Ref<number> = ref(15)
const allElementsCount: Ref<number> = ref(0)
const isLoading: Ref<boolean> = ref(false)
const unexpectedEventAndAlertStatuse: Ref<unexpectedEventsAndLongTimeContinuousDrivingExtensions[]> = ref([])
const errors: Ref<any> = ref({})
const windowInnerWidth = ref(window.innerWidth);
const isManagementOffice: Ref<boolean> = ref(false)
const isSubManagementOffice: Ref<boolean> = ref(false)
const isOperationOffice: Ref<boolean> = ref(false)
const isDepartment: Ref<boolean> = ref(false)
const searched: Ref<boolean> = ref(false)
const unexpectedEventModalStatus: Ref<boolean> = ref(false)
const deleteItem = ref({} as unexpectedEventsAndLongTimeContinuousDrivingExtensions)
const deleteModalStatus: Ref<boolean> = ref(false)
const accounts: Ref<getAccountResponse[]> = ref([])
const selectedUnexpectedEvent = ref({} as unexpectedEventsAndLongTimeContinuousDrivingExtensions)
const updateAuthority: Ref<boolean> = ref(true)
const deleteAuthority: Ref<boolean> = ref(true)
const searchParams = reactive({
  page: 1,
  sort: "start_time",
  sort_type: "DESC",
  includes_start_or_end_time: 'start_time',
  daterange: "",
} as getUnexpectedEventAndLongTimeDrivingExtensionsType);
const isDisplayInitialMessage: Ref<boolean> = ref(false)

window.addEventListener('resize', handleResize);

const props = __props

onMounted(() => {
  getAuthority()
  getSelfAccount()
  getAccounts()
})

async function getAuthority() {
  const authorityList = await AuthorityCacheApi.getWithParse()
  updateAuthority.value = !!authorityList["octlink.daily_report.update"]
  deleteAuthority.value = !!authorityList["octlink.daily_report.delete"]
}

function getSelfAccount() {
  props.switchContentLoading(true)
  Api().getSelfAccount().then((data: SelfAccountType) => {
    isManagementOffice.value = data.login_organization_type == MANAGEMENT_OFFICE_TYPE
    isSubManagementOffice.value = data.login_organization_type == SUB_MANAGEMENT_OFFICE_TYPE
    isOperationOffice.value = data.login_organization_type == OPERATION_OFFICE_TYPE
    isDepartment.value = data.login_organization_type == DEPARTMENT_OFFICE_TYPE
    props.switchContentLoading(false)
    if (isOperationOffice.value || isDepartment.value) return getInitialList()
  })
}

function getAccounts() {
  Api().autoCompleteAccounts(undefined).then((data: getAccountResponse[]) => {
    accounts.value = data
  })
}

async function getInitialList() {
  isLoading.value = true
  let selfDepartment = [] as getDepartmentResponse[]
  let selfOperationOffice = {} as getOperationOfficeResponse | SelfOfficeType
  if (isDepartment.value) {
    selfDepartment = await getDepartment()
  }
  selfOperationOffice = await getSelfOffice()
  searchList(makeRequestParams(selfOperationOffice, selfDepartment), false)
}

async function getDepartment() {
  let department = [] as getDepartmentResponse[]
  await Api().autoCompleteDepartments().then((data: getDepartmentResponse[]) => {
    department = data
  })
  return department
}

function makeRequestParams(operationOffice: getOperationOfficeResponse | SelfOfficeType, departments: getDepartmentResponse[] = []) {
  let startTime = new Date()
  startTime.setDate(startTime.getDate() - 3)
  startTime = new Date(startTime)
  const department = departments.length == 1 ? departments[0] : null

  return {
    managementOffice: {
      type: operationOffice.management_officeable_type,
      id: operationOffice.management_officeable_id
    },
    operationOffice: {
      id: operationOffice.id
    },
    department: {
      id: department?.id
    },
    dateRange: [
      new Date(startTime),
      new Date()
    ],
    division: SELECTABLE_STATUSES[0]
  }
}

function searchList (form: any, isExec: boolean) {
  isDisplayInitialMessage.value = !isExec
  searchParams.page = 1
  searchParams.management_officeable_type = form.managementOffice?.type
  searchParams.management_officeable_id = form.managementOffice?.id
  searchParams.operation_office_id = form.operationOffice?.id
  searchParams.group_id = form.group?.id
  searchParams.department_id = form.department?.id
  searchParams.car_id = form.vehicle?.id
  searchParams.driver_id = form.driver?.driver_id
  searchParams.account_id = form.driver?.id
  searchParams.daterange = `${convertDateTimeTodate(form.dateRange[0])} - ${convertDateTimeTodate(form.dateRange[1])}`
  searchParams.includes_start_or_end_time = form.includes_start_or_end_time
  searchParams.division = form.division.value
  getUnexpectedEventAndLongTimeDrivingExtensions()
}

function convertDateTimeTodate(datetime: Date) {
  if (!datetime) return ''
  return formatDate(datetime, '/')
}

function getUnexpectedEventAndLongTimeDrivingExtensions() {
  isLoading.value = true
  searched.value = true
  Api().getUnexpectedEventAndLongTimeDrivingExtensions(searchParams).then((data: getPagenatedUnexpectedEventAndLongTimeContinuousDrivingExtensionsType) => {
    unexpectedEventAndAlertStatuse.value = data.data
    currentPage.value = data.current_page
    totalPage.value = data.total_page
    itemsPerPage.value = data.per_page
    allElementsCount.value = data.total
    isLoading.value = false
  }).catch((error: any) => {
    isLoading.value = false
    return errorHandle(error.response)
  })
}

function errorHandle (res: any) {
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      props.showFlash(i18n.global.t('pages.common.messages.forbidden'), "error", true)
      break
    case 422:
      errors.value = res.data.errors
  }
}

function handleResize() {
  windowInnerWidth.value = window.innerWidth;
}

function openUnexpectedModal(item: unexpectedEventsAndLongTimeContinuousDrivingExtensions) {
  unexpectedEventModalStatus.value = true
  selectedUnexpectedEvent.value = item
}

function openDeleteConfirmModal(item: unexpectedEventsAndLongTimeContinuousDrivingExtensions) {
  deleteModalStatus.value = true
  deleteItem.value = item
}

function makeFlash(message: string, show: boolean, type: string, fadeout: boolean) {
  const flashType = type == "info" ? "success" : type
  props.showFlash(message, flashType, fadeout)
}

watch(currentPage, () => {
  searchParams.page = currentPage.value
  getUnexpectedEventAndLongTimeDrivingExtensions()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.unexpectedEventAndAlertStatuses.title')), 1),
          _withDirectives(_createElementVNode("p", { class: "ml-5 pb-1 mb-1 align-self-end operation-office-initial-announce" }, _toDisplayString(_unref(i18n).global.t('pages.common.list.initialMessage')), 513), [
            [_vShow, isDisplayInitialMessage.value]
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(UnexpectedEventAndAlertStatuseList, {
            class: "mb-2",
            isOperationOffice: isOperationOffice.value,
            isDepartment: isDepartment.value,
            searched: searched.value,
            unexpectedEventAndAlertStatuse: unexpectedEventAndAlertStatuse.value,
            isLoading: isLoading.value,
            accounts: accounts.value,
            deleteAuthority: deleteAuthority.value,
            openUnexpectedModal: openUnexpectedModal,
            openDeleteConfirmModal: openDeleteConfirmModal
          }, null, 8, ["isOperationOffice", "isDepartment", "searched", "unexpectedEventAndAlertStatuse", "isLoading", "accounts", "deleteAuthority"]),
          _createVNode(PaginateWithCount, {
            class: "justify-end",
            totalPage: totalPage.value,
            modelValue: currentPage.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
            itemsPerPage: itemsPerPage.value,
            allElementsCount: allElementsCount.value,
            showItemCount: true
          }, null, 8, ["totalPage", "modelValue", "itemsPerPage", "allElementsCount"])
        ])
      ]),
      _createVNode(SearchForm, {
        isLoading: isLoading.value,
        isManagementOffice: isManagementOffice.value,
        isSubManagementOffice: isSubManagementOffice.value,
        isOperationOffice: isOperationOffice.value,
        isDepartment: isDepartment.value,
        onSearch: searchList
      }, null, 8, ["isLoading", "isManagementOffice", "isSubManagementOffice", "isOperationOffice", "isDepartment"])
    ]),
    _createVNode(UnexpectedEventModals, {
      modelValue: unexpectedEventModalStatus.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((unexpectedEventModalStatus).value = $event)),
      selectedUnexpectedEvent: selectedUnexpectedEvent.value,
      getUnexpectedEventAndLongTimeDrivingExtensions: getUnexpectedEventAndLongTimeDrivingExtensions,
      updateAuthority: updateAuthority.value,
      showFlash: makeFlash
    }, null, 8, ["modelValue", "selectedUnexpectedEvent", "updateAuthority"]),
    (deleteModalStatus.value)
      ? (_openBlock(), _createBlock(DeleteModal, {
          key: 0,
          modelValue: deleteModalStatus.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((deleteModalStatus).value = $event)),
          deleteItem: deleteItem.value,
          getUnexpectedEventAndLongTimeDrivingExtensions: getUnexpectedEventAndLongTimeDrivingExtensions,
          showFlash: props.showFlash
        }, null, 8, ["modelValue", "deleteItem", "showFlash"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})